type ServerSentEvent = {
	data: string
	event: string
}

/** Parses one SSE block without coupling transport parsing to the UI. */
export function parseServerSentEventBlock(
	block: string,
): ServerSentEvent | null {
	let event = 'message'
	const data: string[] = []
	for (const line of block.split(/\r?\n/)) {
		if (!line || line.startsWith(':')) continue
		const separator = line.indexOf(':')
		const field = separator < 0 ? line : line.slice(0, separator)
		const value =
			separator < 0 ? '' : line.slice(separator + 1).replace(/^ /, '')
		if (field === 'event') event = value
		if (field === 'data') data.push(value)
	}
	return data.length > 0 ? { data: data.join('\n'), event } : null
}
